/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShiftReport } from '../../models/shift-report';

export interface GetShiftReport$Params {
  workCenterId: number;
  shiftId: number;
}

export function getShiftReport(http: HttpClient, rootUrl: string, params: GetShiftReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ShiftReport>> {
  const rb = new RequestBuilder(rootUrl, getShiftReport.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('shiftId', params.shiftId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShiftReport>;
    })
  );
}

getShiftReport.PATH = '/api/v1/ShiftReport/{workCenterId}/GetShiftReport/{shiftId}';
